import BaseService from '@/ecm/common/BaseService.js'
import Utils from '@/ecm/common/Utils.js'

class DelegationService {
  baseUrl = 'delegation';

  getGrid = () => Utils.grid.getParameters(`${this.baseUrl}/get-grid`);
  finish = (id) => BaseService.post({ url: `${this.baseUrl}/finish/${id}` });
  start = (id) => BaseService.post({ url: `${this.baseUrl}/start/${id}` });
  delete = (id) => BaseService.post({ url: `${this.baseUrl}/delete/${id}` });
  save = (delegation) => BaseService.post({ url: `${this.baseUrl}/save`, data: delegation });
}

export default new DelegationService()
